// Egresos del gestor (7-oct-2026).
export const managementExpenses = {
  categories: {
    cleaning: "Ménage",
    laundry: "Blanchisserie",
    maintenance: "Entretien et réparations",
    supplies: "Fournitures et consommables",
    utilities: "Charges (eau, énergie)",
    staff: "Personnel",
    software: "Logiciels et outils",
    marketing: "Publicité",
    taxes: "Impôts et taxes",
    other: "Autres",
  },

  restricted: "Les dépenses de gestion ne sont visibles que par le compte principal : votre accès est limité à certains logements.",

  summary: {
    aria: "Résumé des dépenses de la période. Sélectionnez un montant pour filtrer le tableau.",
    total: "Total des dépenses",
    count: "{n} dépense | {n} dépenses",
    charged: "Refacturées aux propriétaires",
    chargedHint: "Déduites de leurs relevés",
    own: "Propres à la gestion",
    ownHint: "Réduisent votre bénéfice",
  },

  toolbar: {
    search: "Rechercher",
    searchPlaceholder: "Libellé ou fournisseur",
    clearSearch: "Effacer la recherche",
    category: "Catégorie",
    allCategories: "Toutes",
    listing: "Logement",
    allListings: "Tous",
    type: "Type",
    allTypes: "Toutes",
    charged: "Refacturées au propriétaire",
    own: "Propres",
    create: "Nouvelle dépense",
  },

  table: {
    date: "Date",
    category: "Catégorie",
    concept: "Libellé",
    listing: "Logement",
    chargedTo: "À la charge de",
    amount: "Montant",
    receipt: "Justificatif",
    actions: "Actions",
    general: "Général",
    management: "Gestion",
    ownerMissing: "Aucun propriétaire attribué",
    notCharged: "Ce logement n'est plus géré : cette dépense n'est facturée à personne",
    vat: "TVA {pct} %",
    download: "Télécharger le justificatif",
    edit: "Modifier",
    remove: "Supprimer",
  },

  empty: {
    title: "Aucune dépense sur cette période",
    text: "Enregistrez ce que vous payez (ménage, blanchisserie, réparations, logiciels…) et choisissez si c'est refacturé au propriétaire ou si c'est une dépense de la gestion.",
    create: "Enregistrer une dépense",
    filteredTitle: "Aucune dépense ne correspond aux filtres",
    filteredText: "Essayez une autre recherche ou retirez les filtres pour voir toutes les dépenses de la période.",
    clear: "Retirer les filtres",
  },

  load: {
    error: "Impossible de charger les dépenses.",
    retry: "Réessayer",
  },

  remove: {
    title: "Supprimer cette dépense ?",
    message: "« {concept} » ({amount}) ne sera plus prise en compte dans l'analyse ni dans les relevés des propriétaires.",
    confirm: "Supprimer",
    done: "Dépense supprimée",
    error: "Impossible de supprimer la dépense. Veuillez réessayer.",
  },

  receiptError: "Impossible de télécharger le justificatif.",

  drawer: {
    newTitle: "Nouvelle dépense",
    editTitle: "Modifier la dépense",
    newSubtitle: "Ce que vous payez pour la gestion, à la charge du propriétaire ou de votre société de gestion.",
    editSubtitle: "Les modifications apparaissent aussitôt dans l'analyse et dans les relevés.",
    close: "Fermer",
    sections: {
      expense: "La dépense",
      listing: "Logement et propriétaire",
      notes: "Notes",
      receipt: "Justificatif ou facture",
    },
    fields: {
      concept: "Libellé",
      conceptPlaceholder: "Ex. : Ménage de départ",
      category: "Catégorie",
      date: "Date",
      supplier: "Fournisseur",
      supplierPlaceholder: "Ex. : Blanchisserie du Soleil",
      amount: "Montant",
      vat: "TVA",
      vatHint: "À titre indicatif : le montant est ce que vous avez payé, TVA comprise.",
      listing: "Logement",
      listingGeneral: "Dépense générale de la gestion (sans logement)",
      unit: "Unité",
      unitAll: "Tout le logement",
      notesPlaceholder: "Tout détail dont vous voulez vous souvenir",
    },
    charge: {
      label: "Refacturer au propriétaire",
      general: "Une dépense générale est toujours à la charge de la gestion. Choisissez un logement pour la facturer à son propriétaire.",
      loading: "Vérification du logement…",
      error: "Impossible de vérifier si ce logement est géré.",
      retry: "Réessayer",
      notManaged: "Ce logement n'est pas marqué comme géré : la dépense compte comme la vôtre.",
      notManagedMarked: "Ce logement n'est plus géré : la dépense n'est facturée à personne. Désactivez l'option pour la garder comme dépense propre.",
      own: "Si vous ne la refacturez pas, elle compte comme dépense propre de la gestion.",
      owner: "Elle sera déduite du relevé de {owner}.",
      noOwner: "Ce logement n'a pas encore de propriétaire attribué : elle sera déduite du relevé de la personne que vous attribuerez.",
    },
    receipt: {
      drop: "Glissez ici la photo ou le PDF",
      pick: "ou choisissez un fichier",
      formats: "JPG, PNG, WEBP, HEIC ou PDF · 10 Mo max.",
      current: "Justificatif enregistré",
      download: "Télécharger",
      change: "Remplacer",
      remove: "Retirer",
      undo: "Annuler",
      willRemove: "Le justificatif sera retiré à l'enregistrement.",
      willReplace: "remplacera celui enregistré",
      tooBig: "Le fichier dépasse 10 Mo.",
      badType: "Format non pris en charge : ajoutez une photo (JPG, PNG, WEBP ou HEIC) ou un PDF.",
    },
    errors: {
      required: "Ce champ est obligatoire.",
      category: "Choisissez une catégorie.",
      amount: "Saisissez un montant supérieur à 0.",
      vat: "Saisissez un pourcentage entre 0 et 100.",
      review: "Vérifiez les champs signalés.",
      generic: "Impossible d'enregistrer la dépense. Veuillez réessayer.",
    },
    discard: {
      title: "Abandonner les modifications ?",
      message: "Ce que vous avez saisi pour cette dépense sera perdu.",
      confirm: "Abandonner",
      cancel: "Continuer la saisie",
    },
    cancel: "Annuler",
    save: "Enregistrer la dépense",
    saveChanges: "Enregistrer",
    saving: "Enregistrement…",
    created: "Dépense enregistrée",
    updated: "Modifications enregistrées",
    outOfPeriod: "Enregistrée. Sa date ({date}) est en dehors de la période affichée.",
  },
};
